import type { GlobalSharedApprovalDto } from '@ori/global-api-client-react';

export const applyNegative = (data: GlobalSharedApprovalDto, isNegative: boolean): GlobalSharedApprovalDto => {
  if (isNegative) {
    const negative: GlobalSharedApprovalDto = {
      personalData: !data.personalData,
      contact: !data.contact,
      marketingOriflame: !data.marketingOriflame,
      marketingExternal: !data.marketingExternal,
      publication: !data.publication,
      newsletters: !data.newsletters,
      uplineLeaderData: !data.uplineLeaderData,
      uplineLeaderBrowse: !data.uplineLeaderBrowse,
      orderHistory: !data.orderHistory,
      marketingConsultant: !data.marketingConsultant,
      blockGuaranteeOrdering: !data.blockGuaranteeOrdering,
      optedOutOfSponsorSelect: !data.optedOutOfSponsorSelect,
    };

    return negative;
  }

  return data;
};
